import {queryOptions} from '@github-ui/react-query'
import type {SafeHTMLString} from '@github-ui/safe-html'

export const markdownPreviewQueryOptions = (
  value: string,
  onRenderPreview: (markdown: string) => Promise<SafeHTMLString>,
) =>
  queryOptions({
    queryKey: ['markdown-editor-preview', value],
    queryFn: () => onRenderPreview(value),
    // Markdown previews never change for each value, so they never become stale
    staleTime: Infinity,
    // No persistor: there's no benefit to persisting Markdown previews since they'll rarely be reused after a reload
  })
